<template>
  <CardModule class="mt-6" title="Config. Adicionais">
    <div class="lojas-gerenciar-configs-plus-form">
      <!-- PERGUNTAS FREQUENTES -->
      <v-container class="px-0 py-4 mb-8" fluid>
        <v-row class="mb-n15 ml-1">
          <h1 class="lojas-gerenciar-configs-plus-subtitle">
            Perguntas Frequentes
          </h1>
        </v-row>
        <v-row class="justify-end mb-3 mr-1">
          <v-btn
            height="45"
            @click="
              $loja_gerenciar.openModal(
                'modal-body-perguntas-frequentes',
                'new',
                'question',
                '',
                ''
              )
            "
            class="button btn-border btn-right"
          >
            <v-icon dark class="mr-2"> mdi-plus </v-icon>
            Adicionar pergunta
          </v-btn>
        </v-row>
        <v-row class="mb-5">
          <v-divider></v-divider>
        </v-row>
        <v-simple-table
          fixed-header
          class="lojas-gerenciar-dados-cadastrais-container083"
          v-if="
            $loja_gerenciar.cadastro.configuracoes_adicionais
              .perguntas_frequentes.length >= 1
          "
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="(header, index) in headersPerguntas"
                  :key="index"
                  class="text-center table-header"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(question, index) in $loja_gerenciar.cadastro
                  .configuracoes_adicionais.perguntas_frequentes"
                :key="index"
              >
                <td class="text-center">{{ question.ordem }}</td>
                <td class="text-center">
                  {{
                    $config.convertTagString(question.pergunta).length >= 50
                      ? $config
                          .convertTagString(question.pergunta)
                          .substring(0, 70) + "..."
                      : $config.convertTagString(question.pergunta)
                  }}
                </td>
                <td
                  class="text-center"
                  v-html="
                    $config.convertTagString(question.resposta).substring(0, 70)
                      .length >= 50
                      ? $config
                          .convertTagString(question.resposta)
                          .substring(0, 70) + '...'
                      : $config.convertTagString(question.resposta)
                  "
                ></td>
                <td class="table-actions">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="$config.dados.corinputs"
                        height="30"
                        width="30"
                        small
                        icon
                        dark
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $loja_gerenciar.openModal(
                            'modal-body-perguntas-frequentes',
                            'edit',
                            'question',
                            question,
                            index
                          )
                        "
                      >
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="$config.dados.corinputs"
                        height="30"
                        width="30"
                        small
                        icon
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $loja_gerenciar.remover(
                            index,
                            'question',
                            '',
                            'Deseja realmente excluir esta pergunta?'
                          )
                        "
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Deletar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-row class="ml-2 mt-3 mb-10" v-else>
          <span>Não há registro de perguntas para esta loja.</span>
        </v-row>
      </v-container>
      <!-- FIM PERGUNTAS FREQUENTES -->

      <!-- REDES SOCIAIS -->
      <v-container class="px-0 py-4 mb-8" fluid>
        <v-row class="mb-n15 ml-2">
          <h1 class="lojas-gerenciar-configs-plus-subtitle">Redes Sociais</h1>
        </v-row>
        <v-row class="justify-end mb-3 mr-1">
          <v-btn
            height="45"
            @click="
              $loja_gerenciar.openModal(
                'modal-body-redes-sociais',
                'new',
                'social',
                '',
                ''
              )
            "
            class="button btn-border"
          >
            <v-icon dark class="mr-2"> mdi-plus </v-icon>
            Adicionar rede social
          </v-btn>
        </v-row>
        <v-row class="mb-5">
          <v-divider></v-divider>
        </v-row>
        <v-simple-table
          fixed-header
          class="lojas-gerenciar-dados-cadastrais-container083"
          v-if="
            $loja_gerenciar.cadastro.configuracoes_adicionais.redes_sociais
              .length >= 1
          "
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="(header, index) in headersRedesSociais"
                  :key="index"
                  class="text-center table-header"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(social, index) in $loja_gerenciar.cadastro
                  .configuracoes_adicionais.redes_sociais"
                :key="index"
              >
                <td class="text-center">{{ social.ordem }}</td>
                <td class="text-center">{{ social.titulo }}</td>
                <td class="text-center">{{ social.valor }}</td>
                <td class="table-actions">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="$config.dados.corinputs"
                        height="30"
                        width="30"
                        small
                        icon
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $loja_gerenciar.openModal(
                            'modal-body-redes-sociais',
                            'edit',
                            'social',
                            social,
                            index
                          )
                        "
                        class="mr-2"
                      >
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="$config.dados.corinputs"
                        height="30"
                        width="30"
                        small
                        icon
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $loja_gerenciar.remover(
                            index,
                            'social',
                            '',
                            'Deseja realmente excluir esta rede social?'
                          )
                        "
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Deletar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-row class="ml-2 mt-3 mb-10" v-else>
          <span>Não há registro de redes sociais para esta loja.</span>
        </v-row>
      </v-container>
      <!-- </div> -->
      <!-- FIM REDES SOCIAIS -->

      <!-- CONTATO -->
      <v-container class="px-0 py-4 mb-8" fluid>
        <v-row class="mb-n15 ml-1">
          <h1 class="lojas-gerenciar-configs-plus-subtitle">Contato</h1>
        </v-row>
        <v-row class="justify-end mb-3 mr-1">
          <v-btn
            height="45"
            @click="
              $loja_gerenciar.openModal(
                'modal-body-contato',
                'new',
                'contact',
                '',
                ''
              )
            "
            class="button btn-border"
          >
            <v-icon dark class="mr-2"> mdi-plus </v-icon>
            Adicionar contato
          </v-btn>
        </v-row>
        <v-row class="mb-5">
          <v-divider></v-divider>
        </v-row>
        <v-simple-table
          fixed-header
          class="lojas-gerenciar-dados-cadastrais-container083"
          v-if="
            $loja_gerenciar.cadastro.configuracoes_adicionais.contato.length >=
            1
          "
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="(header, index) in headersContato"
                  :key="index"
                  class="text-center table-header"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(contact, index) in $loja_gerenciar.cadastro
                  .configuracoes_adicionais.contato"
                :key="index"
              >
                <td class="text-center">{{ contact.ordem }}</td>
                <td class="text-center">{{ contact.titulo }}</td>
                <td class="text-center">{{ contact.valor }}</td>
                <td class="table-actions">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="$config.dados.corinputs"
                        height="30"
                        width="30"
                        small
                        icon
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $loja_gerenciar.openModal(
                            'modal-body-contato',
                            'edit',
                            'contact',
                            contact,
                            index
                          )
                        "
                        class="mr-2"
                      >
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="$config.dados.corinputs"
                        height="30"
                        width="30"
                        small
                        icon
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $loja_gerenciar.remover(
                            index,
                            'contact',
                            '',
                            'Deseja realmente excluir este contato?'
                          )
                        "
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Deletar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-row class="ml-2 mt-3 mb-10" v-else>
          <span>Não há registro de contatos para esta loja.</span>
        </v-row>
      </v-container>
      <!-- FIM CONTATO -->

      <!-- POLITICAS -->
      <!-- <v-container class="px-0 py-4 mb-8" fluid>
        <v-row class="mb-n15 ml-1">
          <h1 class="lojas-gerenciar-configs-plus-subtitle">
            Política de Privacidade
          </h1>
        </v-row>
        <v-row class="justify-end mb-3 mr-1">
          <v-btn
            height="45"
            @click="
              $loja_gerenciar.openModal(
                'modal-body-politicas',
                'new',
                'policy',
                '',
                ''
              )
            "
            class="button btn-border"
            :disabled="policiesIsEmpty"
          >
            <v-icon dark>
              {{ $config.icons.plus }}
            </v-icon>
            Adicionar política
          </v-btn>
        </v-row>
        <v-row class="mb-5">
          <v-divider></v-divider>
        </v-row>
        <v-simple-table
          fixed-header
          class="lojas-gerenciar-dados-cadastrais-container083"
          v-if="
            $loja_gerenciar.cadastro.configuracoes_adicionais.politicas
              .length >= 1
          "
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="(header, index) in headersPoliticas"
                  :key="index"
                  class="text-center table-header"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(policy, index) in $loja_gerenciar.cadastro
                  .configuracoes_adicionais.politicas"
                :key="index"
              >
                <td class="text-center">
                  {{ $config.convertTagString(policy.titulo) }}
                </td>
                <td class="table-actions">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="$config.dados.corinputs"
                        height="30"
                        width="30"
                        x-small
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $loja_gerenciar.openModal(
                            'modal-body-politicas',
                            'edit',
                            'policy',
                            policy,
                            index
                          )
                        "
                        class="lojas-gerenciar-dados-cadastrais-button button button-bg"
                      >
                        <EditIcon />
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :color="$config.dados.corinputs"
                        height="30"
                        width="30"
                        x-small
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="lojas-gerenciar-button01"
                        @click="
                          $loja_gerenciar.remover(
                            index,
                            'policy',
                            '',
                            'Deseja realmente excluir esta politica?'
                          )
                        "
                      >
                        <DeleteIcon />
                      </v-btn>
                    </template>
                    <span>Deletar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-row class="ml-2 mt-3 mb-10" v-else>
          <span
            >Não há registro de políticas de privacidade para esta loja.</span
          >
        </v-row>
      </v-container> -->
      <!-- </div> -->
      <!-- FIM POLITICAS -->

      <!-- CONTATO SAC -->
      <v-container class="px-0 py-4 mb-8" fluid>
        <v-row class="mb-4 ml-1">
          <h1 class="lojas-gerenciar-configs-plus-subtitle">Contato SAC</h1>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-3">
          <v-col cols="6">
            <BaseTextField
              label="Link"
              hide-details
              v-model="
                $loja_gerenciar.cadastro.configuracoes_adicionais.contato_sac
              "
              placeholder="Insira o texto do contato"
              type="text"
            >
            </BaseTextField>
          </v-col>
          <v-col cols="6">
            <BaseTextField
              label="E-mail contato"
              required
              v-model="
                $loja_gerenciar.cadastro.configuracoes_adicionais.contato_email
              "
              placeholder="Insira o e-mail"
              type="text"
              :rules="[rules.required]"
            >
            </BaseTextField>
          </v-col>
        </v-row>
      </v-container>
      <!-- FIM CONTATO SAC -->
    </div>
  </CardModule>
</template>
<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import mixins from "../../../mixins";
const { formRules } = mixins;
export default {
  name: "AddictionalSettings",
  mixins: [LojasGerenciarMixins, formRules],
  components: {
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
  },
  destroyed() {
    this.$loja_gerenciar.limpaFormularioDeLoja();
  },
  computed: {
    policiesIsEmpty: {
      get() {
        if (
          this.$loja_gerenciar.cadastro.configuracoes_adicionais.politicas
            .length <= 0 ||
          this.$loja_gerenciar.cadastro.configuracoes_adicionais.politicas ===
            null ||
          this.$loja_gerenciar.cadastro.configuracoes_adicionais.politicas ===
            undefined ||
          this.$loja_gerenciar.cadastro.configuracoes_adicionais.politicas ===
            ""
        ) {
          return false;
        }
        return true;
      },
      set() {},
    },
  },
};
</script>
<style scoped>
.lojas-gerenciar-configs-plus-subtitle {
  width: 487px;
  font-size: 1em;
  align-self: flex-start;
  margin-top: 20px;
}

.lojas-gerenciar-config-plus {
  margin-top: 20px;
  width: 100%;
  height: 100%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}

.lojas-gerenciar-configs-plus-form {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}

.lojas-gerenciar-dados-cadastrais-container083 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  border-radius: 20px;
  flex-direction: column;
}

.lojas-gerenciar-dados-cadastrais-button {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
